import {Stack, Alert, useTheme, Chip } from '@mui/material';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { CloudUpload } from '@mui/icons-material';

export default function Files({id, label, onAdd, onDelete, value, error, loading, accept}){

    const theme = useTheme()

    const [err, setErr] = useState(error || false)
    const [active, setActive] = useState(false)
    const maxSize = 10000000;

    const handleFiles = files => {

        setErr(false);

        let newFiles = []

        for(let i = 0; i < files.length; i++){

            let file = files[i]

            if((value || []).map(v => v.name).includes(file.name)){

                return setErr(`Il existe déjà un fichier nommé ${file.name}`);

            }else if(Array.isArray(accept) && !accept.includes(file.type)){

                return setErr(`Le format du fichier ${file.name} n'est pas accepté`);

            }else if( file.size > maxSize ){

                return setErr(`Le fichier ${file.name} est trop volumineux`);
            }
                    
            file.url = URL.createObjectURL(file);

            newFiles.push(file)
        }

        return onAdd(newFiles)
    }


    const handleDelete = file => {
        setErr(false)
        return onDelete(file);
    }

    const handleDownload = file => {
        if(file?.url) window.open(file.url, '_blank').focus();
    }

    const handleChange = e => {
        let files = e.target.files;
        if(files && files.length) handleFiles(files)
    }

    const handleDrop = e => {
        e.preventDefault();
        let files = e.dataTransfer.files;
        return (files && files.length) ? handleFiles(files) : false;
    }

    const handleDrag = e => {
        e.preventDefault();
        setActive(true)
    }

    const handleDragLeave = e => {
        e.preventDefault();
        setActive(false)
    }

    return <Stack spacing={1}>

        <Stack 
            sx={{
                height: 100, 
                border: 'dashed 2px', 
                borderColor: active ? theme.palette.primary.light : 'lightgrey',
                borderRadius: '5px'
            }}
            onMouseEnter={() => setActive(true)}
            onMouseLeave={() => setActive(false)}
        >

            <LoadingButton
                startIcon={<CloudUpload />}
                onClick={() => document.getElementById(id).click()}
                loading={loading}
                sx={{height: '100%'}}
                onDrop={handleDrop}
                onDragOver={handleDrag}
                onDragEnter={handleDrag}
                onDragLeave={handleDragLeave}
            >
                {label || 'Joindre des fichiers'}
            </LoadingButton>

        </Stack>
        

        {Array.isArray(value) && 

            <Stack direction='row' flexWrap='wrap'>

                {value.map(file => 
                    <Chip 
                        label={file.name}
                        onClick={() => handleDownload(file)}
                        onDelete={() => handleDelete(file)}
                        sx={{mr: 0.5, mb: 0.5}}
                        key={file.name}
                    />    
                )}

            </Stack>
        }

        {err && <Alert severity='error'>{err}</Alert>}

        <input 
            id={id}
            type="file"
            onChange={handleChange}
            style={{display: 'none'}}
            accept={Array.isArray(accept) ? accept.join(',') : undefined}
            multiple
        />

    </Stack>

}

